/* Built In Imports */
import { useRouter } from 'next/router';
import React, { createRef, useEffect, useState } from 'react';

/* External Imports */
import {
    Box,
    Button,
    Flex,
    FormControl,
    FormErrorMessage,
    FormLabel,
    Input, Select,
    Text
} from '@chakra-ui/react';
import { Field, Form, Formik } from 'formik';
import ReCAPTCHA from 'react-google-recaptcha';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { useMediaQuery } from 'react-responsive';
import * as Yup from 'yup';

/* Internal Imports */
/* Components */
import Loader from '@components/Utility/Loader';
import config from '@config';
import CountriesList from '@constants/NewsletterCountriesList';
import AmericanCountriesList from '@constants/AmericanCountriesList';

/* Services */
import { addAllInOneSubscription } from '@services/newsletterService';

/**
 *
 * @param count
 * @param sectionContent
 */

const NewsLetterPopup = ({ count, sectionContent, selItems, setMessagePop }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [isCaptchaVis, setIsCaptchaVis] = useState(true);  
  const [loading, setLoading] = useState(false);
  const router = useRouter();
  const recaptchaRef = createRef();
  const isMobile = useMediaQuery({ maxWidth: 960 });
  // React.memo(countries);
  
  const clickHandler = () => {
    setIsOpen(!isOpen);
  };

  // split region from url and show appropriate country in dropdown by region
  let urlpath = router.asPath;               
  let splitURL= urlpath.toString().split("/");
  let countries = '';
  if(splitURL[1] === 'us' || splitURL[1] === 'ca'){
    countries = AmericanCountriesList;
  } else {
    countries = CountriesList;
  }
  React.memo(countries);
      
  const ValidationSchema = Yup.object().shape({
    name: Yup.string()
      .matches(/^([a-zA-Z ])+$/u, {
        message: 'Name is invalid',
      })
      .min(2, 'Name is invalid')
      .max(100, 'Name is invalid')
      .required('Name is required'),
    email: Yup.string()
      .matches(/^[a-zA-Z]+[a-zA-Z0-9._]+@[a-zA-Z]+\.[a-zA-Z.]{2,15}$/, {
        message: 'Email is invalid',
      })
      .required('Email is required'),
    country: Yup.string()
      .required('Country is required')
  });

  const alertUser = e => {
    e.preventDefault();
    e.returnValue = '';
  };

  useEffect(() => {
    window.addEventListener('beforeunload', alertUser);
    return () => {
      window.removeEventListener('beforeunload', alertUser);
    };
  }, []);

  const validateReCaptcha = (value) => {
    let error;
    if (!value) error = 'Please verify you are human!';
    return error;
  };

  const onSubmit = async (values, { setSubmitting, resetForm }) => {
    setLoading(true);
    let formValues = values;
    formValues.list = selItems;
    setSubmitting(true);
    let formResponse = await addAllInOneSubscription(formValues);
    setSubmitting(false);

    if (typeof formResponse === 'string') {
      setMessagePop(
        `<div>Sorry something went wrong. We are not able to process your request right now 1. </div>`
      );      
      setIsCaptchaVis(false);
      setIsCaptchaVis(true);
    } if (formResponse?.status_code === 500) {
      setMessagePop(formResponse?.message_template);      
      setIsCaptchaVis(false);
      setIsCaptchaVis(true);
    } else if (
      formResponse[0]?.status_code === 101 ||
      formResponse[0]?.status_code === 102 ||
      formResponse[0]?.status_code === 103 ||
      formResponse[0]?.status_code === 104 ||
      formResponse[0]?.status_code === 105 ||
      formResponse[0]?.status_code === 106 ||
      formResponse[0]?.status_code === 500
    ) {
      if (formResponse[0]?.status_code === 106 || formResponse[0]?.status_code === 101 || formResponse[0]?.status_code === 102) {
        resetForm();
      }
      setMessagePop(formResponse[0]?.message_template);      
      setIsCaptchaVis(false);
      setIsCaptchaVis(true);
    } else {
      setIsCaptchaVis(false);
      setIsCaptchaVis(true);
      setMessagePop(
        `<div>Sorry something went wrong. We are not able to process your request right now.</div>`
      );
    }
    
    setLoading(false);
    window.dataLayer.push({
      event: 'newsletter_success',
      source: `${config.cdnPath}${router.asPath}`
    });
    const popupUrl =
      router.asPath.indexOf('?popup=1') > -1
        ? router.asPath
        : router.asPath.indexOf('?') > -1
          ? `${router.asPath}&popup=1`
          : `${router.asPath}?popup=1`;
    window.history.pushState(window.history.state, '', popupUrl);
    window['loc'] = popupUrl;
    setLoading(false);
  };

  return (
    <>
      <Box
        w="89.5%"
        maxW="980px"
        height={!isOpen ? '93px ' : 'auto'}
        overflow="hidden"
        transition="height 1s"
        background="#F9F2E6"
        pos="fixed"
        bottom="0"
        zIndex={10}
        borderRadius="10px 10px 0px 0px"
        left="50%"
        transform={'translate(-50%, 0%)'}
        padding={{ base: '20px', md: '30px 50px 0 50px' }}
        boxShadow="0px 100px 80px rgba(0, 0, 0, 0.07), 0px 64.8148px 46.8519px rgba(0, 0, 0, 0.0531481), 0px 38.5185px 25.4815px rgba(0, 0, 0, 0.0425185), 0px 20px 13px rgba(0, 0, 0, 0.035), 0px 8.14815px 6.51852px rgba(0, 0, 0, 0.0274815), 0px 1.85185px 3.14815px rgba(0, 0, 0, 0.0168519)"
      >
        <Flex
          w="100%"
          h="auto"
          justifyContent="space-between"
          alignItems="center"
          pb="20px"
          cursor={isOpen ? 'default': 'pointer'}
          onClick={!isOpen && clickHandler}
        >
          <Box as="span" rounded="full">
            <Box
              as="span"
              background="#DED5C3"
              width="35px"
              height="35px"
              borderRadius="100%"
              textAlign="center"
              color="#000000"
              display="inline-flex"
              alignItems="center"
              justifyContent="center"
              fontFamily="FedraSansStd-Book"
              fontStyle="normal"
              fontWeight="600"
              fontSize={{ base: "16px", md: "20px" }}
              lineHeight="25px"
              textTransform="uppercase"
              fontFeatureSettings="'case' on"
            >
              {count}
            </Box>
            &nbsp;
            <Text
              as="span"
              fontFamily="FedraSansStd-A-medium"
              fontStyle="normal"
              fontWeight="500"
              fontSize={{ base: "16px", md: "20px" }}
              lineHeight="35px"
              pb="10px"
              ml={{ base: "5px", md: "15px" }}
              color="#28231E"
            >
              {sectionContent.content?.json?.formTitle || 'Newsletters Selected'}
            </Text>
          </Box>
          <Box
            as="span"
            background="#CF4520"
            width="35px"
            height="35px"
            borderRadius="100%"
            fontWeight="bold"
            textAlign="center"
            color="#ffffff"
            display="flex"
            alignItems="center"
            justifyContent="center"
            fontSize="15px"
            onClick={clickHandler}
            cursor="pointer"
          >
            {isOpen && <FiChevronDown fontSize="25px" style={{ fontWeight: '900' }} />}
            {!isOpen && <FiChevronUp fontSize="25px" style={{ fontWeight: '900' }} />}
          </Box>
        </Flex>
        <Formik
          validationSchema={ValidationSchema}
          enableReinitialize
          initialValues={{
            name: '',
            email: '',
            country: '',
            language: 'en',
            source: `${config.BASE_PATH}${router.asPath}`,
            newsletters: {
              "AllinOne": "AllinOne"
            },
            list: {              
            },
            recaptcha: ''
          }}
          onSubmit={onSubmit}
        >
          {props => (
            <Form onSubmit={props.handleSubmit}>
              
              <Box
                fontFamily="FedraSansStd-Book"
                display="flex"
                justifyContent="space-between"
                alignItems="flex-start"
                flexWrap="wrap"
                w="100%"
                height="auto"
              >
                <Flex
                  w="100%"
                  justifyContent="flex-start"
                  flexDir={{ base: "column", md: "row" }}
                >
                  <Field name="name" p={{ base: "0", md: "0 10px" }} width={{ base: "100%", md: "33%" }}>
                    {({ field, form }) => (
                      <FormControl
                        isRequired
                        isInvalid={form.errors.name && form.touched.name}
                        maxWidth="100%"
                        p={{ base: "0", md: "0 10px" }}
                      >
                        <Box>
                          <FormLabel mt="7px" mb="5px">{sectionContent.content?.json?.fieldLabelFullName || 'Name'}</FormLabel>
                          <Input
                            {...field}
                            background="#FFFFFF"
                            borderRadius="3px"
                            fontFamily="FedraSansStd-Book"
                            border="0"
                            // minWidth="205px"
                            placeholder="Enter Name"
                            isRequired={true}
                          />
                          <FormErrorMessage>{form.errors.name}</FormErrorMessage>
                        </Box>
                      </FormControl>
                    )}
                  </Field>
                  <Field name="email" p={{ base: "0", md: "0 10px" }} width={{ base: "100%", md: "33%" }}>
                    {({ field, form }) => (
                      <FormControl
                        isRequired
                        isInvalid={form.errors.email && form.touched.email}
                        maxWidth="100%"
                        p={{ base: "0", md: "0 10px" }}
                      >
                        <Box>
                          <FormLabel mt="7px" mb="5px">{sectionContent.content?.json?.fieldLabelEmail || 'Email'}</FormLabel>
                          <Input
                            background="#FFFFFF"
                            borderRadius="3px"
                            {...field}
                            isRequired={true}
                            fontFamily="FedraSansStd-Book"
                            placeholder="Enter Email"
                            border="0"
                            // minWidth="205px"
                          />
                          <FormErrorMessage justifyContent="left">
                            {form.errors.email}
                          </FormErrorMessage>
                        </Box>
                      </FormControl>
                    )}
                  </Field>
                  <Field name="country" p={{ base: "0", md: "0 10px" }} width={{ base: "100%", md: "33%" }}>
                    {({ field, form }) => (
                      <FormControl
                        isRequired
                        isInvalid={form.errors.country}
                        maxWidth="100%"
                        p={{ base: "0", md: "0 10px" }}
                      >
                        <Box>
                          <FormLabel mt="7px" mb="5px">Country</FormLabel>
                          <Select
                            background="#FFFFFF"
                            borderRadius="3px"
                            border="0"
                            fontFamily="FedraSansStd-Book"
                            {...field}
                            isRequired={true}
                          >
                            <option key="" value="">Select</option>
                            {
                            countries.map(country => (
                              <option key={country.name} value={country.value}>{country.name}</option>
                            ))}
                          </Select>
                          <FormErrorMessage>
                            {form.errors.country}
                          </FormErrorMessage>
                        </Box>
                      </FormControl>
                    )}
                  </Field>
                </Flex>
                {isMobile && isCaptchaVis && (
                  <Flex
                    w="100%"
                    justifyContent="flex-end"
                    flexDirection={{ base: "column", md: "row"}}
                  >
                    <Field id="popup-captcha" name="recaptcha" maxWidth="100%" p="0 10px" validate={validateReCaptcha}>
                      {({ field, form }) => (
                        <FormControl
                          isInvalid={
                            form.errors.recaptcha && form.touched.recaptcha
                          }
                          width={{ base: 'auto', xl: 'auto' }}
                          m={{ base: '0', xl: '0' }}
                          maxWidth="100%"
                          display="flex"
                          justifyContent="center"
                          p="20px 0 10px"
                        >
                          {config.RECAPTCHA_KEY && (
                            <ReCAPTCHA
                              ref={recaptchaRef}
                              sitekey={config.RECAPTCHA_KEY}
                              onChange={success => {
                                success === null
                                  ? recaptchaRef.current.reset()
                                  : props.setFieldValue('recaptcha', success);
                              }}
                              onErrored={error => {
                                props.setFieldValue('recaptcha', '');
                                recaptchaRef.current.reset();
                              }}
                              w="100%"
                              className="popup-captcha"
                            />
                          )}
                          <FormErrorMessage justifyContent="center">
                            {form.errors.recaptcha}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                    <Button
                      type="submit"
                      fontFamily="FedraSansStd-Book"
                      disabled={
                        !props.isValid || !props.dirty || loading ? true : false
                      }
                      w={{ base: "100", md: "auto" }}
                      m={{ base: "0 auto", md: "14px 0 0 0" }}
                      maxW="304px"
                    >
                      {sectionContent.content?.json?.submitButton || 'Subscribe'}
                    </Button>
                  </Flex>
                )}
                
                {!isMobile && isCaptchaVis && (
                  <Flex
                    w="100%"
                    justifyContent="center"
                  >
                    <Field name="recaptcha" maxWidth="100%" validate={validateReCaptcha}>
                      {({ field, form }) => (
                        <FormControl
                          isInvalid={
                            form.errors.recaptcha && form.touched.recaptcha
                          }
                          width={{ base: 'auto', xl: 'auto' }}
                          m={{ base: '0', xl: '0' }}
                          maxWidth="100%"
                          display="flex"
                          justifyContent="center"
                          p="20px 0 0"
                          className="popup-captcha"
                        >
                          {config.RECAPTCHA_KEY && (
                            <ReCAPTCHA
                              ref={recaptchaRef}
                              sitekey={config.RECAPTCHA_KEY}
                              onChange={success => {
                                success === null
                                  ? recaptchaRef.current.reset()
                                  : props.setFieldValue('recaptcha', success);
                              }}
                              onErrored={error => {
                                props.setFieldValue('recaptcha', '');
                                recaptchaRef.current.reset();
                              }}
                              w="100%"
                            />
                          )}
                          <FormErrorMessage justifyContent="center">
                            {form.errors.recaptcha}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>

                    <Button
                      type="submit"
                      fontFamily="FedraSansStd-Book"
                      disabled={
                        !props.isValid || !props.dirty || loading ? true : false
                      }
                      w={{ base: "100%", md: "auto" }}
                      m={{ base: "0 auto", md: "34px 0 0 -50px" }}
                      maxW="304px"
                    >
                      {sectionContent.content?.json?.submitButton || 'Subscribe'}
                    </Button>
                  </Flex>
                )}
              </Box>
              <style>
                {
                  `.popup-captcha iframe {
                    transform:scale(0.77);
                    -webkit-transform:scale(0.77);
                    transform-origin:0 0;
                    -webkit-transform-origin:0 0;
                  }`
                }

              </style>
            </Form>
          )}
        </Formik>
      </Box>
      
      {loading && (
        <Box w="100%" position="fixed" left="0" top="0" bgColor="rgba(0, 0, 0, 0.48)" height="100%" zIndex="9888" textAlign="center" display={'block'}>
          <Loader pos="relative" />
        </Box>
      )}
    </>
  );
};

export default NewsLetterPopup;
